import { Component, ElementRef, Input, OnChanges, OnInit, Renderer2, SimpleChanges, ViewChild } from "@angular/core";

@Component({
    selector: 'app-video-player',
    templateUrl: './video-player.component.html',
    styleUrls: ['./video-player.component.scss']
})
export class VideoPlayerComponent implements OnInit, OnChanges {
  @Input() videoSrc: string = '';
  @Input() title = '';
  @Input() videoHeight: number = 360;
  @Input() videoWidth: number = 640;

  @ViewChild('wistiaPlayerContainer', { static: true }) wistiaPlayerContainer!: ElementRef<HTMLElement>;

  private wistiaPlayerEl: HTMLElement | null = null;
  private wistiaScriptEl: HTMLScriptElement | null = null;

  constructor(
    private readonly renderer: Renderer2,
    private readonly elementRef: ElementRef<HTMLElement>
  ) {}

  ngOnInit(): void {
    this.renderWistiaPlayer();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['videoSrc'] && !changes['videoSrc'].isFirstChange()) {
      this.renderWistiaPlayer();
    }
  }

  /**
   * Creates the per-media Wistia <script> and <wistia-player> elements imperatively instead of
   * via the template.
   */
  private renderWistiaPlayer(): void {
    if (!this.videoSrc) return;

    const host = this.elementRef.nativeElement;
    if (this.wistiaScriptEl) {
      this.renderer.removeChild(host, this.wistiaScriptEl);
      this.wistiaScriptEl = null;
    }

    const script = this.renderer.createElement('script') as HTMLScriptElement;
    this.renderer.setAttribute(script, 'src', `https://fast.wistia.com/embed/${this.videoSrc}.js`);
    this.renderer.setAttribute(script, 'async', '');
    this.renderer.setAttribute(script, 'type', 'module');
    this.renderer.appendChild(host, script);
    this.wistiaScriptEl = script;

    const container = this.wistiaPlayerContainer.nativeElement;
    if (this.wistiaPlayerEl) {
      this.renderer.removeChild(container, this.wistiaPlayerEl);
      this.wistiaPlayerEl = null;
    }

    const player = this.renderer.createElement('wistia-player');
    this.renderer.setAttribute(player, 'media-id', this.videoSrc);
    this.renderer.setAttribute(player, 'seo', 'false');
    let aspectRatio = this.videoWidth / this.videoHeight;
    this.renderer.setAttribute(player, 'aspect', aspectRatio.toString());
    if (this.title) {
      this.renderer.setAttribute(player, 'title', this.title);
    }
    this.renderer.appendChild(container, player);
    this.wistiaPlayerEl = player;
  }
}